import { useCrud } from '@/hooks/useCrud'
import OfferService from '../offer.service'
import { API_RESOURCE } from '@/constants/api.constant'
import { useQuery } from '@tanstack/react-query'
import { createOptions } from '@/utils/arrayHelper'
import {
  MyOfferDisplayLevel,
  MySourcingOfferDisplayLevel,
} from '@/features/tableProfiles/constants/tableProfile.constant'

const useOfferList = () => {
  const service = new OfferService()
  const baseCrud = useCrud(API_RESOURCE.OFFER, service)

  const useOfferOptions = (parameter = {}) => {
    const { labelKey = 'quotationNumber', valueKey = '_id', withNilOption = false, ...rest } = parameter
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { ...rest } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { ...rest } }),
      placeholderData: [],
      select: (data) => {
        return createOptions(data?.data, labelKey, valueKey, withNilOption)
      },
      enabled: Object.values(rest).every((value) => value !== undefined),
      refetchOnMount: true,
    })
  }

  return {
    useFetchMyOffers: (parameter, displayLevel = MyOfferDisplayLevel.OFFER, options = {}) => {
      let baseUrl = 'my'
      if (displayLevel && displayLevel !== '') {
        baseUrl = `my/${displayLevel}`
      } else {
        baseUrl = `my/${MyOfferDisplayLevel.OFFER}`
      }
      return baseCrud.useFetchAll(parameter, baseUrl, options)
    },
    useFetchMySourcingOffers: (parameter, displayLevel = MySourcingOfferDisplayLevel.COST_BUDGET, options = {}) => {
      let baseUrl = 'mySourcing'
      if (displayLevel && displayLevel !== '') {
        baseUrl = `mySourcing/${displayLevel}`
      } else {
        baseUrl = `mySourcing/${MySourcingOfferDisplayLevel.COST_BUDGET}`
      }
      return baseCrud.useFetchAll(parameter, baseUrl, options)
    },
    useFetchMaintenanceSummary: (parameter) => baseCrud.useFetchAll(parameter, 'maintenanceSummary'),
    useFetchOfferApprovals: (parameter) => baseCrud.useFetchAll(parameter, 'approvals'),
    useFetchOfferParticipations: (parameter) => baseCrud.useFetchAll(parameter, 'participations'),
    useFetchOfferSourcingDecisions: (parameter) => baseCrud.useFetchAll(parameter, 'sourcingDecisions'),
    useFetchOfferVendorRFQs: (parameter) => baseCrud.useFetchAll(parameter, 'vendorRFQs'),
    useFetchVendorRFQTenderDocOptions: () => baseCrud.useFetchAll({ page: 1, pageSize: 0 }, 'vendorRFQs/options'),
    useFetchVendorQuotations: (parameter) => baseCrud.useFetchAll(parameter, 'vendors/quotations'),
    useFetchPRApprovals: (parameter) => baseCrud.useFetchAll(parameter, 'pr-approvals'),
    useFetchGCPRApprovals: (parameter, options = {}) => baseCrud.useFetchAll(parameter, 'gcpr-approvals', options),
    useFetchGCPRMaterials: (parameter) => baseCrud.useFetchAll(parameter, 'gcpr-material'),

    //Count
    useCountOfferParticipation: (parameter) => baseCrud.useCount(parameter, 'participations'),
    useCountOfferMaintenanceSummary: (parameter) => baseCrud.useCount(parameter, 'maintenanceSummary'),

    useOfferOptions,
  }
}

export default useOfferList
